<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import ShiftEmployeePanel from '../../../../../../shifts/components/panels/ShiftEmployeePanel.vue'
import { Shift } from '../../../../../../shifts/models/shift'
import { SiteID } from '../../../../../../sites/models/site'

definePage({
  props: true,
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
    hideLeftColumn: true,
    hideRightColumn: true,
  },
})

const { siteId, shift } = defineProps<{
  siteId: SiteID
  shift: Shift
}>()
</script>

<template>
  <ShiftEmployeePanel :site-id="siteId" :shift="shift" />
</template>
